import { useBaseApiMutation } from "@mutation/baseMutation";

export const useChallengeUpdateMutation = (postUuid) =>{

    return useBaseApiMutation(
        {
            method: "PUT",
            endpoint: `/organization/me/challenge/${postUuid}`
        }
    )
}

export const useChallengeClubCreateMutation = () =>{

    return useBaseApiMutation(
        {
            method: "POST",
            endpoint: `/organization/me/challenge/club/{club_uuid}`
        }
    )
}

export const useChallengeSiteCreateMutation = () =>{

    return useBaseApiMutation(
        {
            method: "POST",
            endpoint: `/organization/me/challenge/site/{site_uuid}`
        }
    )
}

